export default __webpack_public_path__ + "static/screen-1-3abf55488f59b41bb994bf2956825248.png";